import MasterBoxes from '@/components/Boxes/MasterBoxes.vue';
import BoxIndex from '@/components/Boxes/Index.vue';
import BoxActions from '@/components/Boxes/BoxActions.vue';
import BoxHeader from '@/components/Boxes/BoxHeader.vue';
import BoxMenu from '@/components/Boxes/SubMenu.vue';
import BoxSectionHeader from '@/components/Boxes/BoxSectionHeader.vue';
import BoxSectionActions from '@/components/Boxes/BoxSectionActions.vue';
import BoxList from '@/components/Boxes/BoxList.vue';
import BoxListMenu from '@/components/Boxes/BoxMenuList.vue';
import BoxSectionMenu from '@/components/Boxes/BoxSectionMenu.vue';

import DetailsMaster from '@/components/Boxes/Details_Master.vue';
import BoxDetails from '@/components/Boxes/Details.vue';
import DetailsSource from '@/components/Boxes/DetailsSources.vue';
import DetailsConstraints from '@/components/Boxes/DetailsConstraints.vue';
import DetailsBranding from '@/components/Boxes/DetailsBranding.vue';
import DetailsFilters from '@/components/Boxes/DetailsFilters.vue';

export default {
  path: '/:stationUid/boxes',
  components: {
    default: MasterBoxes,
    menu: BoxListMenu
  },
  children: [
    {
      name: 'BoxesHome',
      path: '',
      redirect: 'list/MUSIC', // redirect boxes to music section
      components: {
        default: BoxIndex,
        subPageHeader: BoxSectionHeader,
        pageSubMenu: BoxSectionMenu,
        pageActions: BoxSectionActions
      }
    },
    {
      name: 'BoxList',
      path: 'list/:boxType/:filter?',
      components: {
        default: BoxList,
        subPageHeader: BoxSectionHeader,
        pageSubMenu: BoxSectionMenu,
        pageActions: BoxSectionActions
      }
    },
    {
      path: ':boxUid',
      components: {
        default: DetailsMaster,
        subPageHeader: BoxHeader,
        pageActions: BoxActions,
        pageSubMenu: BoxMenu
      },
      children: [
        {
          name: 'SmartBoxFilters',
          path: 'filters',
          component: DetailsFilters
        },
        {
          name: 'BoxDetails',
          path: 'details',
          component: BoxDetails
        },
        // {
        //     name:'SmartBoxSources',
        //     path: 'sources',
        //     component: DetailsSource,
        // },
        {
          name: 'BoxConstraints',
          path: 'constraints',
          component: DetailsConstraints
        },
        {
          name: 'BoxBranding',
          path: 'branding',
          component: DetailsBranding
        }
      ]
    }
  ]
};
